// extracted by mini-css-extract-plugin
export default {"spinner":"app_spinner__-g4Wq","backGroungForVideo":"app_backGroungForVideo__TO51b"};